<div class="dp-loading-indicator-wrap">
	<div class="dp-loading-indicator-inner">
		<div class="dp-loader-text"><ng-content></ng-content></div>
		<ion-progress-bar type="indeterminate"></ion-progress-bar>
	</div>
</div>
